import styled from 'styled-components'

export const H1 = styled.div(`
  font-size: calc(1.2em + 3vw) !important;
`)



// WEBPACK FOOTER //
// ./src/styled/h.js